// extracted by mini-css-extract-plugin
module.exports = {"number":"AnimateNumber_number__zQZKd"};